/* PastéBCN — Fly to cart (solo PDP)
   Al confirmarse la adición al carrito, clona la imagen activa de la galería
   y la hace volar en arco hasta el icono de carrito del header, que rebota
   al recibirla.

   Reglas duras:
   - Decorativa: NUNCA bloquea ni retrasa el añadir. Todo va en try/catch;
     si algo falla, el flujo de compra sigue intacto.
   - Se dispara con la confirmación (PUB_SUB_EVENTS.cartUpdate filtrado por
     source 'product-form'), no con el click. Si la adición falla, se publica
     cartError y aquí no llega nada.
   - Solo transform y opacity. Sin reflow.
   - prefers-reduced-motion: reduce → se salta entera (se comprueba con
     matchMedia, coherente con el bloque CSS de pastebcn-product.css).

   El header de la ficha usa el patrón Headroom (ver pastebcn-header.js). Si
   está oculto al confirmar, se le pide que se muestre con su propio
   mecanismo (_applyState) y se mide DESPUÉS de la transición, para que la
   tarta aterrice en el icono y no en el aire. No se toca la lógica de
   scroll: al terminar, el header vuelve a mandar solo. */

(function () {
  'use strict';

  var FLIGHT_MS = 650;
  var BOUNCE_MS = 300;
  var EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';
  var HEADER_REVEAL_MS = 300; // igual que la transición de .pb-header
  var HEADER_REVEAL_TIMEOUT = 450; // red de seguridad si no llega transitionend

  var current = null; // { anim, clone } de la animación en curso

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function inViewport(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    return r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
  }

  function cleanup() {
    if (!current) return;
    var clone = current.clone;
    current = null;
    if (clone && clone.parentNode) clone.parentNode.removeChild(clone);
  }

  /* Si el header está oculto, pídele que se muestre con SU mecanismo y
     resuelve cuando la transición haya terminado. Nunca deja el header
     pinneado a la fuerza: solo cambia de estado, y el scroll del usuario
     vuelve a gobernarlo en cuanto se mueva. */
  function ensureHeaderVisible() {
    return new Promise(function (resolve) {
      var header = document.querySelector('pb-header');
      if (!header || !header.classList.contains('pb-header--unpinned')) {
        resolve();
        return;
      }
      if (typeof header._applyState !== 'function') {
        resolve();
        return;
      }

      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        header.removeEventListener('transitionend', onEnd);
        resolve();
      };
      var onEnd = function (e) {
        if (e.target === header && e.propertyName === 'transform') finish();
      };

      header.addEventListener('transitionend', onEnd);
      header._applyState('pb-header--pinned');
      window.setTimeout(finish, reducedMotion() ? 0 : HEADER_REVEAL_TIMEOUT);
    });
  }

  function buildClone(img, rect) {
    var clone = document.createElement('img');
    clone.src = img.currentSrc || img.src;
    clone.className = 'pb-fly-clone';
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('alt', '');
    clone.style.top = rect.top + 'px';
    clone.style.left = rect.left + 'px';
    clone.style.width = rect.width + 'px';
    clone.style.height = rect.height + 'px';
    return clone;
  }

  function bounceCart(icon) {
    try {
      if (typeof icon.animate !== 'function') return;
      icon.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }],
        { duration: BOUNCE_MS, easing: EASE }
      );
    } catch (e) {
      /* decorativo: si falla, no pasa nada */
    }
  }

  /* Arco: horizontal lineal, vertical con ease-in. Se construyen keyframes
     intermedios porque una sola transición daría línea recta. */
  function arcKeyframes(dx, dy) {
    var frames = [];
    var steps = 20;
    for (var i = 0; i <= steps; i++) {
      var t = i / steps;
      var x = dx * t; // lineal
      var y = dy * (t * t); // ease-in → la caída se acelera
      var scale = 1 - 0.8 * t; // 1 → 0.2
      var opacity = t < 0.8 ? 1 : 1 - (t - 0.8) / 0.2; // fade en el último 20%
      frames.push({
        transform: 'translate3d(' + x + 'px, ' + y + 'px, 0) scale(' + scale + ')',
        opacity: opacity,
        offset: t,
      });
    }
    return frames;
  }

  function fly() {
    // Cancela cualquier vuelo en curso: nada de clones huérfanos.
    if (current) {
      try {
        if (current.anim) current.anim.cancel();
      } catch (e) {
        /* noop */
      }
      cleanup();
    }

    var img = document.querySelector('.pb-product-gallery__slide.is-active .pb-product-gallery__img');
    if (!img) return; // producto sin imagen → sin animación, sin placeholder

    var icon = document.querySelector('#cart-icon-bubble');
    if (!inViewport(icon)) return; // ni tras revelar el header → se salta

    var from = img.getBoundingClientRect();
    if (!from.width || !from.height) return;
    var to = icon.getBoundingClientRect();

    var clone = buildClone(img, from);
    document.body.appendChild(clone);

    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);

    if (typeof clone.animate !== 'function') {
      // Sin Web Animations API: no animamos, pero tampoco dejamos basura.
      clone.parentNode.removeChild(clone);
      return;
    }

    var anim = clone.animate(arcKeyframes(dx, dy), {
      duration: FLIGHT_MS,
      easing: EASE,
      fill: 'forwards',
    });

    current = { anim: anim, clone: clone };

    anim.onfinish = function () {
      cleanup();
      bounceCart(icon);
    };
    anim.oncancel = function () {
      cleanup();
    };
  }

  function onCartUpdate(payload) {
    try {
      if (!payload || payload.source !== 'product-form') return;
      if (reducedMotion()) return; // sin clon y sin rebote
      if (!document.body.classList.contains('template-product')) return;
      // Si no hay cart-notification/cart-drawer, product-form.js redirige a
      // /cart: animar no tiene sentido.
      if (!document.querySelector('cart-notification, cart-drawer')) return;

      ensureHeaderVisible().then(function () {
        try {
          fly();
        } catch (e) {
          cleanup();
        }
      });
    } catch (e) {
      cleanup();
    }
  }

  var unsubscribe = null;

  /* OJO: constants.js declara `const PUB_SUB_EVENTS`, que es un binding
     léxico global y NO una propiedad de window. `function subscribe` de
     pubsub.js sí cuelga de window. Por eso se resuelven distinto. */
  function pubSubEvents() {
    if (typeof PUB_SUB_EVENTS !== 'undefined') return PUB_SUB_EVENTS;
    if (window.PUB_SUB_EVENTS) return window.PUB_SUB_EVENTS;
    return null;
  }

  function subscribeFn() {
    if (typeof subscribe === 'function') return subscribe;
    if (typeof window.subscribe === 'function') return window.subscribe;
    return null;
  }

  function init() {
    try {
      var events = pubSubEvents();
      var sub = subscribeFn();
      if (!events || !sub) return;
      if (unsubscribe) unsubscribe();
      unsubscribe = sub(events.cartUpdate, onCartUpdate);
    } catch (e) {
      /* decorativo */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // La sección se re-renderiza en el editor y con el Section Rendering API.
  document.addEventListener('shopify:section:load', function () {
    cleanup();
    init();
  });
})();
